import { languageService } from "../../../Language/language.service";

export function sectionSchemaGenerator(title, id, sectionSchema, actions) {
  return {
    title: `Add/Edit ${title}`,
    id: `${id}SectionSchema`,
    stateTitle: {
      create: languageService(`Add ${title}`),
      edit: languageService(`Edit ${title}`),
    },
    sections: [
      {
        id: `${id}InfoSection`,
        fields: sectionSchema.map((section) => {
          let obj = {
            ...section,
            col: 4,
          };

          return obj;
        }),
      },

      //TODO make actions generic too
      {
        id: `${id}FormButtonsSection`,
        fields: [
          {
            id: "addMaterialType", // required
            type: "button", // required
            labelValue: languageService("Add"),
            action: "submit",
            callback: "addMaterialType",
            position: "footer",
            hiddenStates: ["edit"],
            col: 6,
          },
          {
            id: "updateMaterialType", // required
            type: "button", // required
            labelValue: languageService("Update"),
            action: "submit",
            callback: "updateMaterialType",
            position: "footer",
            hiddenStates: ["create"],
            col: 6,
          },
          {
            id: "cancelEquipmentDialog", // required
            type: "button", // required
            labelValue: languageService("Cancel"),
            action: "cancel",
            position: "footer",
            col: 6,
          },
        ],
      },
    ],
  };
}



// WEBPACK FOOTER //
// ./src/components/MaterialTypeListView/utils/sectionSchemaGenerator.js